import React, { useState } from 'react';
import Joi from '@hapi/joi';
import { useSnackbar } from 'notistack';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { messages } from '../common/es_ES';
import { saveProject } from '../../services/projectService';
import { Button, TextField } from '@material-ui/core';
import { notifications } from '../../utils/messages';

const AddProjectForm = ({ history, onClose, open, selectedYear }) => {
  const initialState = {
    data: { name: '', year: '' },
    errors: {},
  };

  const [state, setState] = useState(initialState);
  const { enqueueSnackbar } = useSnackbar();

  const schema = Joi.object({
    id: Joi.string().guid(),
    name: Joi.string().label('Nombre').max(5000).messages(messages),
    slug: Joi.string().label('Slug').max(5000).messages(messages),
    year: Joi.string().label('Año').max(50).messages(messages),
  });

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const { error } = schema.validate(obj);
    return error ? error.details[0].message : null;
  };

  const handleChange = ({ target: input }) => {
    const errors = { ...state.errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...state.data };
    data[input.name] = input.value;
    setState((prevState) => ({ ...prevState, data, errors }));
  };

  const handleSubmit = async () => {
    try {
      const res = await saveProject({
        name: state.data.name,
        year: selectedYear,
      });
      enqueueSnackbar(notifications.SUCCESS, { variant: 'success' });
      history.push('/proyecto/' + res.data.slug);
    } catch (ex) {
      enqueueSnackbar(notifications.NAME, { variant: 'error' });
      
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='form-dialog-title'
      fullWidth={true}
    >
      <DialogTitle id='form-dialog-title'>Nuevo proyecto</DialogTitle>
      <DialogContent>
        <TextField
          error={state.errors['name'] === undefined ? false : true}
          margin='dense'
          name='name'
          label='Nombre del proyecto *'
          type='text'
          fullWidth
          multiline
          maxRows='2'
          variant='outlined'
          size='small'
          onChange={handleChange}
          helperText={state.errors['name']}
        />
        <TextField
          error={state.errors['year'] === undefined ? false : true}
          margin='dense'
          disabled
          name='year'
          label='Año *'
          type='text'
          fullWidth
          variant='outlined'
          size='small'
          onChange={handleChange}
          value={selectedYear}
          helperText={state.errors['year']}
        />
        <Button
          onClick={handleSubmit}
          color='primary'
          className='btn btn-guardar'
          variant='contained'
          margin='normal'
          size='medium'
        >
          Guardar
        </Button>
      </DialogContent>
    </Dialog>
  );
};
export default AddProjectForm;
